function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m387.847656 272 30-91h-87.542968l-10 91zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m290.125 272 10-91h-88.25l10 91zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m124.152344 272h67.542968l-10-91h-87.542968zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m271 0h241v60h-241zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m0 0h241v60h-241zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m30 90h452v61h-452zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m242.507812 362h-46.507812c-36.21875 0-66.523438 25.808594-73.492188 60h-47.507812c-41.355469 0-75 33.644531-75 75v15h196c36.21875 0 66.523438-25.808594 73.492188-60h46.507812c36.21875 0 66.523438-25.808594 73.492188-60h47.507812c41.355469 0 75-33.644531 75-75v-15h-196c-36.21875 0-66.523438 25.808594-73.492188 60zm0 0"
});

function Svg410(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "0 0 512 512",
    width: "512pt",
    fill: "inherit",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg410);
export default __webpack_public_path__ + "static/media/4_10.44fec4a9.svg";
export { ForwardRef as ReactComponent };